import './contracts_table.css';
import React, { useEffect,useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import Widget_count_elements from '../widget_count_elements/widget_count_elements'
import {makeStyles} from '@mui/styles';


function submission_treated(stat){
    return(
      <>
        {
         stat == 0
         ?<Button variant="contained" className="status_deny">refusée</Button>
         :stat == 1
         ?<Button variant="contained" className="status_success">acceptée</Button>
         :<Button variant="contained" className="status_waiting">en cours</Button>
        }
      </>
  
    );
  }

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const columns = [
    { id: 'code', label: "Code de soumission", minWidth: 0 },
    { id: 'Objet', label: "Objet d'appel", minWidth: 0 },
    { id: 'supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'contract_type', label: "Type de contrat", minWidth: 0 },
    { id: 'contract_subTypes', label: "Sous types de contrat", minWidth: 0 }
  ];
  

function Offers({offers,getCategorieById}){
    
    return(
        <>
        {
            offers.map((submission,index1) => (
                <TableRow key={submission.offer_id+"col"+index1}>
                    <TableCell align="left">{submission.submission_id}</TableCell>
                    <TableCell align="left">{submission.offer_object}</TableCell>
                    <TableCell align="left">{submission.supplier_name}</TableCell>
                    <TableCell align="left">{submission.contract_type}</TableCell>
                    <TableCell align="center">{submission.contract_subTypes}</TableCell>
                </TableRow>                
             ))
        }
        </>
    );
}


function Contracts_table({categories,data}) {

    const classes = useStyles();
    const [show_elemnts,setShowing_elements] = useState(false);


    function getCategorieById(id){
        var categorie="";
        categories.map((catg)=>{
          if(catg.id_category == id) categorie = catg.name;
        })
        return categorie;
    }



//////////////////////
/////////////////////////////////////////////////////////
///////////////////////////////////

  return (
    <>
    {
      show_elemnts!==true
        ?<Widget_count_elements setShowing_elements={setShowing_elements} elements_number={data.count} fontColor="#51a5cf" progress={data.progress} />
        :<TableContainer className="contracts_widget_table" component={Paper} onContextMenu={(e) => {e.preventDefault();setShowing_elements(false)}} style={{cursor:'pointer'}} onTouchStartCapture={(e)=>{e.stopPropagation();setShowing_elements(false)}} >
            <Table className={classes.table} aria-label="sticky table">
                <TableHead>
                <TableRow>
                    {
                        columns.map((column) => (
                            <TableCell key={column.id} align="left">{column.label}</TableCell>
                        ))
                    }
                </TableRow>
                </TableHead>
                <TableBody>
                <>
                    <Offers offers={data.last_offers} getCategorieById={getCategorieById} />
                </>
                </TableBody> 
            </Table>
        </TableContainer>
    }
    
      
    </>
    
  );
}

export default React.memo(Contracts_table);
